import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Assets
 */
import NoNotificationsSVG from '../../assets/illustrations/no_notifications.svg';

/**
 * MUI Components
 */
import { Fade } from '@mui/material';

/**
 * Components
 */
import EmptyState from '../EmptyState';
import WorkshopAlertCard from './WorkshopAlertCard';

const styles = {
    notificationList: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
};

const ListVehicleAlerts = ({ items, lastItemRef = null }) => {
    const { t } = useTranslation();
    const [localItems, setLocalItems] = useState(items);

    // Sync local items when items prop changes
    useEffect(() => {
        setLocalItems(items);
    }, [items]);

    const handleDelete = (uuid, notification) => {
        setLocalItems((prevItems) => prevItems.filter((item) => item.id !== uuid));
    };

    if (!Array.isArray(localItems) || localItems.length < 1) {
        return (
            <Fade in={true} >
                <div>
                    <EmptyState
                        message={t('No alerts found')}
                        illustration={NoNotificationsSVG}
                    />
                </div>
            </Fade>
        );
    }

    return (
        <div style={styles.notificationList}>
            {localItems.map((item, index) => {
                const isLast = index === localItems.length - 1;
                return (
                    <div key={item.id} ref={isLast ? lastItemRef : null}>
                        <WorkshopAlertCard alert={item} />
                    </div>
                );
            })}
        </div>
    );
};

export default ListVehicleAlerts;